<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import MultiselectDropdown from '../../../../../shared/components/ui/MultiselectDropdown.vue';

const props = defineProps({
  boards: {
    type: Array,
    default: () => [],
  },
  selectedBoardId: {
    type: [Number, String],
    default: null,
  },
  updateHistory: {
    type: Boolean,
    default: false,
  },
  ticketId: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:selectedBoardId', 'change']);

const store = useStore();

const selectedBoard = computed(() => {
  return props.boards.find(board => board.id === props.selectedBoardId) || {};
});

const handleBoardChange = async newBoard => {
  if (props.disabled) return;
  if (!newBoard || newBoard.id === props.selectedBoardId) return;

  emit('update:selectedBoardId', newBoard.id);
  emit('change', newBoard);

  // If updateHistory is true, update the ticket history
  if (props.updateHistory && props.ticketId) {
    try {
      // Clear board_column_id when board changes
      const response = await store.dispatch('tickets/changeBoard', {
        id: props.ticketId,
        boardId: newBoard.id,
        boardColumnId: null,
      });

      if (response && response.ticket) {
        store.commit('tickets/UPDATE_TICKET', response.ticket);
      }

      // Refresh the ticket history immediately after the change
      await store.dispatch('tickets/getTicketHistory', props.ticketId);
    } catch (error) {
      console.error('Error updating board:', error);
      // Revert the change on error
      emit('update:selectedBoardId', props.selectedBoardId);
    }
  }
};
</script>

<template>
  <div>
    <MultiselectDropdown
      :options="boards"
      :selected-item="selectedBoard"
      multiselector-title="Selecionar Quadro"
      multiselector-placeholder="Selecionar Quadro"
      input-placeholder="Buscar quadro..."
      no-search-result="Nenhum quadro encontrado"
      :has-thumbnail="false"
      :disabled="disabled"
      @select="handleBoardChange"
    />
  </div>
</template>
